import { IAdvertState } from '@/interfaces/store';

const state: IAdvertState = {
  advert: {},
  similar: [],
  stats: null,
};

export default state;
